{{ERROR_ROW error}}
{{#if successfullRequests}}
<div class="m-b-20 p-l-10">{{successfullRequests}} {{partialSuccessText}}</div>
{{/if}}
<div class="form-group full-width-multi-input">
	{{#if name}}
	<label for="{{selectID}}">{{name}}</label><br>
	{{/if}}
	<input data-role="tagsinput" {{#unless hasItems}} placeholder="{{placeholder}}" {{/unless}} id="{{selectID}}" {{#if readOnly}}readonly{{/if}}>
	</input>
</div>
